export default __webpack_public_path__ + "static/media/file_red.7260dbfe.svg";